import _mapValues from 'lodash/mapValues';
import { connect } from 'react-redux';
import { updateCurrentLanguage as _updateCurrentLanguage } from 'js/store/actions/localization';
import { SUPPORTED_LOCALIZATION_LANGUAGE_NAME_MAP } from 'js/constants/localization';
import { getCurrentLanguage, mapLocalizationObjectToLocalizedText } from 'js/helpers/localization';
import LocalizationDropdown from 'js/components/legacy/LocalizationDropdown';
export default connect(function (state) {
  return {
    isMobileWidth: state.device.isMobileWidth,
    currentLanguage: getCurrentLanguage(state),
    supportedLanguageMap: _mapValues(SUPPORTED_LOCALIZATION_LANGUAGE_NAME_MAP, mapLocalizationObjectToLocalizedText)
  };
}, function (dispatch) {
  return {
    updateCurrentLanguage: function updateCurrentLanguage(updatedLanguage) {
      dispatch(_updateCurrentLanguage(updatedLanguage));
    }
  };
})(LocalizationDropdown);